export class NoBillingPackageError extends Error {
  constructor(service: "viewer" | "widget") {
    super(
      `Product owner has no related billing package for service: ${service}`
    );
    this.name = "NoBillingPackageError";
  }
}
